import React, { useState } from "react";
import SectionHead from "./SectionHead";
import Icon from "./Icon";
import "../styles/faq.css";

function FAQ({ items, eyebrow = "FAQ", title = "Common questions", subtitle }) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faq section" id="faq">
      <div className="container">
        <SectionHead eyebrow={eyebrow} title={title} subtitle={subtitle} center />
        <div className="faq-list">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div className={`faq-item ${isOpen ? "faq-item--open" : ""}`} key={item.q}>
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span>{item.q}</span>
                  <Icon name="chevron" className="faq-chevron" />
                </button>
                {isOpen && <p className="faq-answer">{item.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
